import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

/**
 * 개발 모드 감지 및 React Query 환경 설정을 제공하는 컴포넌트
 * - 개발 모드에서만 ReactQueryDevtools를 로드합니다
 * - QueryClient 설정을 제공합니다
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - 자식 컴포넌트
 * @param {Object} props.queryClientOptions - QueryClient 설정 옵션
 */
const AppQueryProvider = ({ children, queryClientOptions }) => {
  // 개발 모드 확인
  const isDev = process.env.NODE_ENV === "development";

  // React Query 클라이언트 설정
  const defaultOptions = {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000, // 기본 5분 캐싱
      },
    },
  };

  // 기본 옵션과 사용자 정의 옵션 병합
  const mergedOptions = { ...defaultOptions, ...queryClientOptions };

  // QueryClient 생성
  const queryClient = React.useMemo(() => new QueryClient(mergedOptions), []);

  // 개발 모드 초기화 확인
  React.useEffect(() => {
    // React Query 초기화 완료
  }, [isDev, mergedOptions]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}

      {/* 개발 모드에서만 ReactQueryDevtools 로드 */}
      {isDev && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      )}
    </QueryClientProvider>
  );
};

export default AppQueryProvider;
